import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './styles.scss'
import globalCss from '../../../../scss/global.scss'
import ToolTip from '../../ToolTip'

export class ChoiceFromDataSourceEditor extends Component {
  constructor ({ variable }) {
    super()
    this.state = {
      selectedDataSource: variable.args[0] || '',
      filters: variable.args[1] || []
    }
    this.acceptableMacros = ['javascript', 'choiceFromDataSourceColumn', 'getter']
  }

  componentWillReceiveProps (nextProps) {
    const { report, save, variableName } = this.props
    const { filters, selectedDataSource } = this.state
    if (nextProps.report === true && report === false) {
      save(variableName, [selectedDataSource, filters])
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const { update } = this.props
    if (prevState !== this.state) {
      update()
    }
  }

  handleUpdateSelectedDataSource = evt => {
    this.setState({
      selectedDataSource: evt.target.value
    })
  }

  generateDataSourceOptions = () => {
    const { dataSources } = this.props
    const options = [<option key='0' value=''>Select Data Source...</option>]
    let index = 1
    for (const dataSourceId in dataSources) { // eslint-disable-line no-unused-vars
      if (dataSources.hasOwnProperty(dataSourceId)) { // eslint-disable-line no-prototype-builtins
        options.push(<option key={`_${index}`} value={dataSourceId}>{dataSources[dataSourceId].name}</option>)
        index++
      }
    }
    return options
  }

  handleAddFilter = () => {
    const filters = this.state.filters
    filters.push({ column: '', value: '', isReference: false })
    this.setState({
      filters: filters
    })
  }

  updateFilterColumn = (columnName, i) => {
    const filters = this.state.filters
    filters[i].column = columnName
    this.setState({
      filters: filters
    })
  }

  updateFilterValue = (filterValue, i, isReference) => {
    const filters = this.state.filters
    filters[i].value = filterValue
    filters[i].isReference = isReference
    this.setState({
      filters: filters
    })
  }

  updateFilterMethod = (method, i) => {
    const { filters } = this.state
    filters[i].method = method
    this.setState({
      filters
    })
  }

  updateFilterOperator = (operator, i) => {
    const { filters } = this.state
    filters[i].operator = operator
    this.setState({
      filters
    })
  }

  generateDSColumnOptions = () => {
    const { selectedDataSource } = this.state
    const { dataSources } = this.props
    if (selectedDataSource === '' || !dataSources[selectedDataSource]) {
      return []
    }
    const options = []
    if (selectedDataSource.length) {
      const columnNames = dataSources[selectedDataSource].columns
      let index = 0
      options.push(<option key={`_${index}`} value=''>Select Column...</option>)
      index++
      for (const name of columnNames) { // eslint-disable-line no-unused-vars
        options.push(<option key={`_${index}`} value={name}>{name}</option>)
        index++
      }
    }
    return options
  }

  deleteFilter = (i) => {
    const { filters } = this.state
    filters.splice(i, 1)
    this.setState({
      filters: filters
    })
  }

  generateVariableList () {
    const { vars, variableName } = this.props
    const varList = []
    Object.keys(vars).forEach(varName => {
      const currentVar = vars[varName]
      let ownGetter = false
      if (currentVar.macro === 'getter' && currentVar.args[0] === variableName) {
        ownGetter = true
      }
      if (variableName !== varName && !ownGetter) {
        const varDeets = vars[varName]
        if (this.acceptableMacros.indexOf(varDeets.macro) > -1) {
          varList.push(
            <option value={varName} key={varName}>{varDeets.name}</option>
          )
        }
      }
    })
    return varList
  }

  generateColumnGetter = (columnName) => {
    const { variableName, generateDataSourceGetter } = this.props
    generateDataSourceGetter(variableName, columnName, false)
  }

  generateFilterList () {
    const { filters } = this.state
    const { app: { primaryColor } } = this.props
    const filterList = []
    const varList = this.generateVariableList()
    const columnOptions = this.generateDSColumnOptions()
    for (const [i, filter] of filters.entries()) { // eslint-disable-line no-unused-vars
      let keywordComponent
      if (filter.isReference) {
        keywordComponent = (
          <div>
            <label>Keyword</label>
            <span className={css.switch}>
              <button onClick={evt => this.updateFilterValue('', i, false)} className={css.switchBtn}>Use Keyword</button>
            </span>
            <div className={css.backer}>
              <select value={filter.value} onChange={evt => this.updateFilterValue(evt.target.value, i, true)} className={css.select}>
                <option value=''>Select a variable</option>
                {varList}
              </select>
            </div>
          </div>
        )
      } else {
        keywordComponent = (
          <div>
            <label>Keyword</label>
            <span className={css.switch}>
              <button onClick={evt => this.updateFilterValue('', i, true)} className={css.switchBtn}>Use a Variable</button>
            </span>
            <input
              className={css.option}
              type='text'
              value={filter.value}
              onChange={evt => this.updateFilterValue(evt.target.value, i, false)}
              placeholder='Enter value'
            />
          </div>
        )
      }

      let operatorComponent = null
      if (i > 0) {
        operatorComponent = (
          <div className={css.backer} style={{ maxWidth: '100px', marginBottom: '15px' }}>
            <select className={css.select} value={filter.operator || 'and'} onChange={evt => this.updateFilterOperator(evt.target.value, i)}>
              <option value="and">AND</option>
              <option value="or">OR</option>
            </select>
          </div>
        )
      }

      filterList.push(
        <div key={i} className={css.wrapper}>
            {operatorComponent}
            <div>
              <label>Filter where:</label>
            </div>
            <div className={css.row} style={{ marginTop: '-7px' }}>
              <div className={css.column} style={ { marginRight: '5px' } }>
                <div className={css.backer}>
                  <select value={filter.column} onChange={evt => this.updateFilterColumn(evt.target.value, i)} className={css.select}>
                    {columnOptions}
                  </select>
                </div>
              </div>
              <div className={css.column}>
                <div className={css.backer} style={ { marginLeft: '5px' } }>
                  <select className={css.select} value={filter.method || 'equals'} onChange={evt => this.updateFilterMethod(evt.target.value, i)}>
                    <option value="equals">Equals</option>
                    <option value="doesNotEqual">Does Not Equal</option>
                    <option value="contains">Contains</option>
                    <option value="doesNotContain">Does Not Contain</option>
                  </select>
                </div>
              </div>
              <div className={css.smallColumn}>
                <button onClick={() => this.deleteFilter(i)} className={css.remove} style={{ color: primaryColor }}>
                  <i className={globalCss.iconMinusCircled} />
                </button>
              </div>
            </div>
            <div className={css.row}>
              <div className={css.column}>
                {keywordComponent}
              </div>
              <div className={css.smallColumn}></div>
            </div>
          </div>
      )
    }
    return filterList
  }

  generateColumnButtons () {
    const { selectedDataSource } = this.state
    const { app: { primaryColor }, dataSources } = this.props
    const buttons = []
    if (selectedDataSource === '' || !selectedDataSource.length || !dataSources[selectedDataSource]) {
      return buttons
    }
    const columnNames = dataSources[selectedDataSource].columns
    for (const [i, name] of columnNames.entries()) { // eslint-disable-line no-unused-vars
      buttons.push(
        <li key={name}>
          <button
            className={css.add}
            onClick={() => this.generateColumnGetter(name)}
            type='button'
            style={{ backgroundColor: primaryColor }}
          >
            {name}
          </button>
        </li>
      )
    }
    return buttons
  }

  render () {
    const { app: { primaryColor } } = this.props
    const dataSourceOptions = this.generateDataSourceOptions()
    const filterList = this.generateFilterList()
    const columnButtons = this.generateColumnButtons()
    const helpText = 'Adding a filter on a column guarantees that only rows meeting that criteria are returned. Filters will be applied in the order that they appear from top to bottom. Note: If no row meets all criteria then the first row will be returned.'
    return (
      <div style={{ marginTop: '10px' }}>
        <label>Data Source</label>
        <div className={css.backer}>
          <select
            className={css.select}
            value={this.state.selectedDataSource}
            onChange={this.handleUpdateSelectedDataSource}
          >
            {dataSourceOptions}
          </select>
        </div>
        <div>
          <div style={{ margin: '15px 0px' }}>
            <label>Add Filters (Optional)</label>
            <ToolTip tips={helpText} minWidth={400} />
          </div>
          <ul>
            {filterList}
          </ul>
          <button
            className={css.add}
            onClick={this.handleAddFilter}
            type='button'
            style={{ backgroundColor: primaryColor }}
          >
            <i className={globalCss.iconPlus} />
          </button>
        </div>
        <div className={css.vars}>
          <h4>Create variables from this row:</h4>
          <ul>
            {columnButtons}
          </ul>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app } = state
  return {
    app
  }
}

export default connect(mapStateToProps)(ChoiceFromDataSourceEditor)



// WEBPACK FOOTER //
// /app/js/components/EditVariable/ChoiceFromDataSourceEditor/index.js